import { Action, createReducer, on } from '@ngrx/store';
import { geolocationUpdated, geolocationUpdateFail, toggleMenuSidebar, authSetStatus, authenticationSuccess, authenticationFail, fetchLocalOptsOk, setLastApiaryTab, newVersionAvailable, cacheReset } from './app.actions';
import { GeoPos } from 'src/app/itemtypes/geo-pos';
import { FeatureSwitches } from 'src/app/core/feature-switches';
import { EnvironmentConfig } from 'src/environments/environment-config';
import { environment } from 'src/environments/environment';
import { LocalOptionValue } from 'src/app/core/local-option-value';

export interface AppState {
  geopos: GeoPos;
  geoposStatus: string;
  geoposAccuracy: number;
  locationUpdates: number;
  locationUpdateFails: number;
  today: Date;
  menuSidebarOpened: boolean;
  authStatus: boolean;
  featureSwitches: FeatureSwitches;
  environment: EnvironmentConfig;
  localoptions: LocalOptionValue[];
  lastApiaryTab: string | null;
  newVersionAvailable: boolean;
}

export const initialApplicationState: AppState = {

  // TODO: this will cause problems, no ?
  // Where is it used
  today: new Date(),

  geopos: null,
  geoposStatus: 'no-support',
  geoposAccuracy: null,
  locationUpdates: 0,
  locationUpdateFails: 0,
  menuSidebarOpened: true,
  authStatus: false,
  featureSwitches: {} as FeatureSwitches,
  environment: {...environment} as EnvironmentConfig,
  localoptions: [],
  lastApiaryTab: null,
  newVersionAvailable: false,
};

const ApplicationReducer = createReducer(
  initialApplicationState,

  on(geolocationUpdated, (state, { position }) => ({
    ...state,
    geopos: {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    },
    geoposStatus: '',
    geoposAccuracy: position.coords.accuracy || null,
    locationUpdates: state.locationUpdates + 1,
  })),

  on(geolocationUpdateFail, (state, { error }) => ({
    ...state,
    geopos: null,
    geoposStatus: error.message,
    locationUpdateFails: state.locationUpdateFails + 1,
  })),

  on(toggleMenuSidebar, (state, { action }) => ({
    ...state,
    menuSidebarOpened: action === 'open'
  })),

  on(authSetStatus, (state, { status }) => ({
    ...state,
    authStatus: status
  })),

  on(authenticationSuccess, (state) => ({
    ...state,
    authStatus: true
  })),
  on(authenticationFail, (state) => ({
    ...state,
    authStatus: false
  })),

  on(fetchLocalOptsOk, (state, { options }) => ({
    ...state,
    localoptions: options
  })),

  on(cacheReset, (state) => ({
    ...state,
    localoptions: []
  })),

  on(setLastApiaryTab, (state, { tab }) => ({
    ...state,
    lastApiaryTab: tab
  })),

  on(newVersionAvailable, (state, { available }) => ({
    ...state,
    newVersionAvailable: available
  }))
);

export function reducer(state: AppState | undefined, action: Action) {
  return ApplicationReducer(state, action);
}
